import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'dayName'})
export class DayNamePipe implements PipeTransform {
    transform(date): string {
        return new Intl.DateTimeFormat('en-US', {weekday: 'long'}).format(new Date(date));
    }
}
